import { Home, HomeDto, HomeGroup, User } from '@lmc/ts-common'
import * as types from '../common/types'
import { MongoAbility } from '@casl/ability'

// The correct type here is HomeDto
export const setHomeDetails = (homeDetails: Home | HomeDto) => ({
  type: types.SET_HOME_DETAILS,
  homeDetails
})

export const setHomeGroup = (homeGroup: HomeGroup) => ({
  type: types.SET_HOME_GROUP,
  homeGroup
})

export const setGlobalUser = (user: User & { privacyOfficer?: boolean }) => ({
  type: types.SET_GLOBAL_USER,
  user
})

export const setSortType = ({
  key,
  sortType
}: {
  key: string
  sortType: string
}) => ({
  type: types.SET_SORT_TYPE,
  key,
  sortType
})

export const toggleActiveFilter = ({
  filterId,
  key,
  value
}: {
  filterId: string
  key: string
  value: object | string
}) => ({
  type: types.TOGGLE_ACTIVE_FILTER,
  filterId,
  key,
  value
})

export const resetFilter = ({ filterId }: { filterId: string }) => ({
  type: types.RESET_FILTER,
  filterId
})

export const resetSelectedFilter = ({
  filterId,
  filterKey
}: {
  filterId: string
  filterKey: string
}) => ({
  type: types.RESET_SELECTED_FILTER,
  filterId,
  filterKey
})

export const toggleLoading = () => ({ type: types.TOGGLE_LOADING })

export const setAbility = (ability: MongoAbility) => ({
  type: types.SET_ABILITY,
  ability
})

export const setPermissionTemplates = (permissionTemplates: {
  permissionTemplates: Record<string, any>[]
}) => ({
  type: types.SET_PERMISSION_TEMPLATES,
  permissionTemplates
})

export const setPermissionsLoading = (loading: boolean) => ({
  type: types.SET_PERMISSIONS_LOADING,
  loading
})
